import * as React from 'react';

export interface CheckProps {
  backgroundColor: string;
  color: string;
}

const CheckSvg = ({ backgroundColor, color }: CheckProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="3" fill={backgroundColor} />
      <path
        d="M9.74993 15.15L6.59993 12L5.54993 13.05L9.74993 17.25L18.7499 8.24995L17.6999 7.19995L9.74993 15.15Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckSvg;
